import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { TDSRequests } from './tds-requests.model';

@Component({
  selector: 'cs-tds-requests',
  standalone: false,
  templateUrl: './tds-requests.component.html',
  styleUrls: ['./tds-requests.component.scss']
})
export class TdsRequestsComponent implements OnInit, OnDestroy {
  public tdsRequests: Array<TDSRequests>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;
  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getTdsRequests()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.tdsRequests = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: TDSRequests): void {
    this.router.navigate(['/crm/customers/tds-approval/approval'], {
      queryParams: { tdsRequestId: request.tdsRequestId }
    });
    this.closeTodo.emit();
  }
}
